import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
	root: {
		width: 24,
		height: 24,
		// transform: "rotate(45deg)",
		// backgroundColor: '#BCBBD0',

		'& > svg': {
			// margin: theme.spacing(2),
			// width: 24,
			// height: 24,
		},
	},
}));

function AddAllAppsIcon(props) {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M1.43945 6C1.43945 5.44772 1.88717 5 2.43945 5H3.9796C5.42324 5 6.66217 6.02822 6.92822 7.44713L7.06938 8.2H19.2785C21.1324 8.2 22.5425 9.8646 22.2377 11.6932L21.3044 17.2932C21.0633 18.7398 19.8117 19.8 18.3452 19.8H9.69931C8.25566 19.8 7.01674 18.7718 6.75069 17.3529L4.96247 7.81571C4.87379 7.34274 4.46082 7 3.9796 7H2.43945C1.88717 7 1.43945 6.55228 1.43945 6Z" fill={props.fill} />
			<path opacity="0.5" fillRule="evenodd" clipRule="evenodd" d="M12 22.5C12 23.3284 11.3284 24 10.5 24C9.67157 24 9 23.3284 9 22.5C9 21.6716 9.67157 21 10.5 21C11.3284 21 12 21.6716 12 22.5ZM18 22.5C18 23.3284 17.3284 24 16.5 24C15.6716 24 15 23.3284 15 22.5C15 21.6716 15.6716 21 16.5 21C17.3284 21 18 21.6716 18 22.5Z" fill={props.fill} />
			<path opacity="0.5" fillRule="evenodd" clipRule="evenodd" d="M11.9919 3.64947L11.9919 1.99998C11.9919 1.44769 12.4396 0.999977 12.9919 0.999977C13.5442 0.999977 13.9919 1.44769 13.9919 1.99998L13.9919 3.66419L14.5859 3.12327C14.9764 2.73274 15.6096 2.73274 16.0001 3.12327C16.3906 3.51379 16.3906 4.14696 16.0001 4.53748L13.7063 6.77815C13.3158 7.16868 12.6827 7.16868 12.2921 6.77815L10.1709 4.49997C9.7804 4.10945 9.7804 3.47628 10.1709 3.08576C10.5615 2.69523 11.1946 2.69523 11.5851 3.08576L11.9919 3.64947Z" fill={props.fill} />
		</svg>
	);
}

export default function SvgIconsColor(props) {
	const classes = useStyles();

	return (
		<div className={classes.root}>
			<AddAllAppsIcon fill={props.fill} fill2={props.fill2} width={props.width} height={props.height} />
		</div>
	);
}